import { API } from "../config/AppConfig";
import { AUDIT_UPLOADS, MY_CHARTS, RECENT_AUDITS } from "../constants/Endpoints";

class MyAuditRepository {

  async getAuditUploads(filterParams) {
    const response = await API.get(AUDIT_UPLOADS, {
      queryParams: {...filterParams, view: "QA"}
    });
    return response;
  }

  async getRecentAudits() {
    const response = await API.get(RECENT_AUDITS, {
      queryParams: {view: "QA"}
    });
    return response;
  }

  async getCharts(query) {
    const response = await API.get(MY_CHARTS, {
      queryParams: query,
    });
    return response;
  }

}

const myAuditRepository = new MyAuditRepository();
export default myAuditRepository;